<div class="security-equivalents-container" id="security-equivalents-component">

  <!--    <div class="security-equivalents-container-row">-->
  <!--        <div class="security-equivalents-container-element">-->
  <!--            <div class="security-equivalents-element-label security-equivalents-add-header">{{ securityCount == 1 ? securityCount + " equivalent security; " + heldCount + " alt if held " : securityCount + " equivalent securities; " + heldCount + " alt if held "}} </div>-->
<!--        </div>-->
<!--    </div>-->
<div class="security-equivalents-container-row">
  <div class="security-equivalents-container-element">
    <div class="security-equivalents-element-label security-equivalents-add-header">{{ getEquivalentsText()}}
      <span id="addSecurityRestrictionsToolTipIcon"
        class="infoIcon" calltoaction
      [calltoactionTemplate]="securityEquivalentsToolTipTemplateRef"></span>
    </div>

    <ng-template #securityEquivalentsToolTipTemplateRef>
      <div>
        <p>Select the securities you want to have considered as "equivalent" to a security when calculating
          a portfolio's allocations. Equivalent securities will not be purchased in place of each other,
        but can be sold.</p>

        <p>You can also select any securities you'd like iRebal to purchase as alternates to a specific
          security held in the portfolio. <strong>Alt if Held</strong> securities are those you'd like
          iRebal to purchase
          instead of a specific security when the <strong>Alt if Held</strong> is already in the account.
          If you specify
        multiple alternates, iRebal will purchase whichever one there's more of in the account.</p>

      </div>
    </ng-template>
  </div>
</div>
<div class="security-equivalents-container-row">
  <div class="security-equivalents-container-element">
    <div class="security-equivalents-element-label">Add Security equivalents</div>
    <div class="security-equivalents-element-input">
      <irb-dropdown-search-multiple
        #equivalentSecuritiesDropdown
        [addNewItem]="addNewSecurityItem"
        (openNewItemFlow)="openNewItemSecurityFlow($event)"
        [(values)]="selectedEquivalentSecurity"
        (search)="getItemsForEquivalentSecuritiesDropdown($event)"
        (selection)="onSingleEquivalentChanged($event)"
        [enableHiddenSearchResults]="true"
        width="140">
      </irb-dropdown-search-multiple>

    </div>
    <div class="security-equivalents-element-input">
      <button [disabled]="(selectedEquivalentSecurity ? selectedEquivalentSecurity.length === 0 : true )"
        class="btn-medium-secondary btn-spacer" (click)="onAddSymbolEquivalent()">Add
        <!--                    <div *ngIf="((selectedEquivalentSecurity?.value === 0) || isAlreadyAddedSecurity())" #singleSecurityEquivalentTooltip-->
        <!--                         tooltip tooltipPosition="bottom" [tooltipTitle]="singleEquivalentToolTipErrorMessage"-->
      <!--                         tooltipClass="error"></div>-->
    </button>

    <!-- <button id="editTaxEquivalentsAltSymbolCreateNewBtn" (click)="onCreateNewSecurity()" class="btn-medium-secondary">Create New</button> -->
  </div>
  <div class="security-equivalents-element-input">
    <button class="btn-medium-secondary btn-security-master-select btn-spacer"
      (click)="showAddMultipleSecuritiesDialog()">Advanced Filter
    </button>
  </div>
</div>

<div class="security-equivalents-container-element">
  <div class="security-equivalents-element-label">Add Category equivalents</div>
  <div class="security-equivalents-element-input">
    <irb-dropdown-search-multiple
      #customCategoriesDropdown
      [addNewItem]="addNewCategoryItem"
      (openNewItemFlow)="openNewItemCategoryFlow($event)"
      [(values)]="selectedCustomCategory"
      (search)="getItemsForCustomCategoriesDropdown($event)"
      (selection)="onCategoryChanged($event)"
      [enableEmptySearchTerm]="true"
      width="140">
    </irb-dropdown-search-multiple>

  </div>
  <div class="security-equivalents-element-input">
    <button [disabled]="(selectedCustomCategory ? selectedCustomCategory.length === 0 : true)"
      class="btn-medium-secondary btn-spacer" (click)="onAddCategoryEquivalent()">Add
      <!--                    <div *ngIf="((selectedCustomCategory?.value === 0) || isAlreadyAddedCategory())" #categoryEquivalentTooltip-->
      <!--                         tooltip tooltipPosition="bottom" [tooltipTitle]="categoryEquivalentToolTipErrorMessage"-->
    <!--                         tooltipClass="error"></div>-->
  </button>

</div>
</div>
</div>
@if (!isUiTest) {
  <irb-inventory-grid
    class="edit-security-equivalents-grid-ag"
    [style.width]="'100%'"
    [gridHeight]="gridHeight"
    [showSideBar]="false"
    [gridOptions]="gridOptions"
    [frameworkComponents]='frameworkComponents'
  (gridReady)="onGridReady($event)"></irb-inventory-grid>
}

</div>

